import React from "react";
import { Navigate } from "react-router-dom";
import { isSuperadminAuthenticated } from "../../services/superadminService";

const SuperadminProtectedRoute: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  if (!isSuperadminAuthenticated()) {
    // No org context to preserve — the panel always re-enters through the OTP.
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
};

export default SuperadminProtectedRoute;
